// DracoCommandContext.js
import { createContext } from "react";

export const DracoCommandContext = createContext({
  setCommandHandler: () => {},
});